import React, { Component } from "react";

import helpers from "../../helpers";

import Menu from "../menus/menu";
import Code from "../menus/code";
import Location from "../menus/location";
import Document from "../menus/document";
import File from "../menus/file";

import Map from "./map";
import ReactiveQR from "../ReactiveQR";

let qrcode = "";

const getQRCode = (code) => {
  let url = new URL(code.data);
  if (
    (url.hostname.indexOf("prinity.io") !== -1 ||
      url.hostname.indexOf("maprint.com") !== -1) &&
    url.hostname !== qrcode
  ) {
    if ("vibrate" in navigator) navigator.vibrate([200]);
    setTimeout(() => {
      qrcode = "";
    }, 2000);
    qrcode = url.hostname;
    location.replace(url);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
};

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      mode: "map",
      file: null,
    };
    this.mapRef = React.createRef();
    this.fileRef = React.createRef();
    this.onChangeFile = this.onChangeFile.bind(this);
  }

  change(mode) {
    this.setState({
      mode,
    });
  }

  async componentDidMount() {
    if (location.search.length > 0) {
      const file = helpers.getUrlParameter("file");
      if (file) {
        window.history.replaceState({}, document.title, "/");
        const data = await helpers.getDocument(file);
        this.setState({ file: data });
        await helpers.addFileToUser({
          userRef: this.state.app.state.userRef,
          file,
        });
        setTimeout(() => {
          this.setState({ file: null });
        }, 7000);
      }
    }
  }

  onChangeFile = (e) => {
    this.mapRef.current.onFile(e.target.files);
  };

  render() {
    let page, text, button, document;

    if (this.state.mode === "scan") {
      page = <ReactiveQR main={this} onCode={(code) => getQRCode(code)} />;
      text = "Scan QR code on printer";
      button = (
        <a
          href="#"
          onClick={() => this.change("map")}
          className="header-icon header-icon-1"
          data-back-button=""
        >
          <i className="far fa-arrow-left"></i>
        </a>
      );
    } else if (this.state.mode == "map") {
      page = (
        <Map
          ref={this.mapRef}
          main={this}
          app={this.state.app}
          file={this.fileRef}
        />
      );
      text = "Scan QR code on printer";
      button = (
        <span className="header-icon header-icon-1" data-menu="menu">
          <i className="far fa-bars"></i>
        </span>
      );
    }

    if (this.state.file) {
      document = <Document file={this.state.file} />;
    }

    return (
      <div id="page">
        <div className="header header-fixed header-logo-app no-shadow">
          <a href="#" className="header-title ultrabold">
            {text}
          </a>
          {button}

          {this.state.mode === "map" && (
            <label className="header-icon header-icon-2 header-icon-map">
              <input
                type="file"
                onChange={this.onChangeFile}
                style={{ display: "none" }}
              />
              <i
                className="fad fa-file-plus"
                style={{ pointerEvents: "none", color: "#0080a2" }}
              ></i>
              File
            </label>
          )}

          {this.state.mode === "scan" && (
            <div
              data-menu="menu-code"
              className="header-icon header-icon-2 header-icon-map"
            >
              <i className="fad fa-keyboard" /> Type
            </div>
          )}
        </div>

        <Menu app={this.state.app} />
        <Location />
        <Code />
        {document}
        <File ref={this.fileRef} app={this.state.app} />

        <div className="page-content header-clear">{page}</div>
        <div className="menu-hider"></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main.js